
export default {
    name: "ShareButton"
};
